// extracted by mini-css-extract-plugin
export default {"createGroupsContainer":"CreateGroupsButton-module__createGroupsContainer___kFNiO"};